import React, { Component } from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import history from './components/History';
import Home from './components/Home';
// import About from './components/About';
import Product from './components/Product';
import Docs from './components/Docs';
import Navbar from './components/MegaNavbar';
import Login from './components/Login';
import Logout from './components/Logout';
import Footer from './components/Footer';
import UnderConstruction from './components/UnderConstruction';
import NoMatch from './components/NoMatch';
import './App.css';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { isLoggedIn: (document.cookie ? true : false) };
    this.setLoggedInFlag = this.setLoggedInFlag.bind(this);
  }

  setLoggedInFlag() {
    this.setState({isLoggedIn: (document.cookie ? true : false)});
  }

  render() {
    return (
      <Router history={history}>
        <div className="App">
          <Navbar isLoggedIn={this.state.isLoggedIn} />
          <Switch>
            <Route exact path="/" component={Home}/>
            <Route path="/product" component={Product}/>
            <Route path="/docs" render={() => <Docs isLoggedIn={this.state.isLoggedIn} setLoggedInFlag={this.setLoggedInFlag}/>} />
            <Route path="/login" render={() => <Login setLoggedInFlag={this.setLoggedInFlag}/>} />
            <Route path="/logout" render={() => <Logout setLoggedInFlag={this.setLoggedInFlag}/>} />
            <Route path="/(about|quickstart|pricing|privacypolicy|termsandconditions)" component={UnderConstruction}/>
            <Route component={NoMatch}/>
          </Switch>
          <Footer />
        </div>
      </Router>
    );
  }
}

export default App;